import { render } from "./AllOrdenesView.vue?vue&type=template&id=e5acb8b2"
import script from "./AllOrdenesView.vue?vue&type=script&lang=js"
export * from "./AllOrdenesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__